{
  "title": "Web Phone",
  "call": "Call",
  "hangup": "Hang Up",
  "idle": "Ready",
  "dialing": "Dialing...",
  "ringing": "Ringing...",
  "established": "In Call",
  "terminated": "Call Ended",
  "ended": "Call Ended",
  "error": {
    "credential": "Authentication failed, please try again",
    "connection": "Connection refused or unreachable (authentication failed)",
    "rejected": "Call failed (no answer or rejected)",
    "media": "Media interrupted (network/relay issue)",
    "micDenied": "Please allow microphone access before calling. If you are in an in-app browser (e.g., LINE), open this page in Chrome or Safari.",
    "micUnsupported": "This browser does not support microphone access. Please use a newer browser such as Chrome or Safari.",
    "micNotFound": "No microphone found. Please connect a microphone and try again.",
    "micHardware": "Microphone unavailable (it may be in use by another app). Close the other app and try again.",
    "micInsecure": "Please open this page over a secure https connection to use the microphone.",
    "audioPlayBlocked": "Autoplay was blocked. Tap the screen to enable call audio.",
    "connectionLost": "Connection lost. Reconnecting automatically…"
  }
}